import { render, staticRenderFns } from "./SubtitleHome.vue?vue&type=template&id=a3c0c6d2&"
import script from "./SubtitleHome.vue?vue&type=script&lang=js&"
export * from "./SubtitleHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports